import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';
import ActionButton from 'form/components/action/action_button.jsx';
import { FormAPI, ProcessAPI } from 'lecom-api';
import { getObjectKeyPath } from '../../../utils/object_utils.js';
import InputAutocomplete from 'form/components/input/autocomplete/input_autocomplete';
import InputCheckbox from 'realize/components/input/input_checkbox';
import InputFile from 'realize/components/input/input_file';
import InputNumber from 'realize/components/input/input_number';
import InputPassword from 'realize/components/input/input_password';
import InputSwitch from 'realize/components/input/input_switch';
import InputRadioGroup from 'form/components/input/input_radio_group';
import InputText from 'realize/components/input/input_text';
import InputTextarea from 'realize/components/input/input_textarea';
import InputSelect from 'realize/components/input/input_select';
import InputSelectSearch from 'realize/components/input/input_select_search';
import InputMasked from 'realize/components/input/input_masked';
import InputHidden from 'realize/components/input/input_hidden';
import InputCurrency from 'form/components/input/input_currency.jsx';
import InputDatepicker from 'realize/components/input/input_datepicker.jsx';
import InputDatepickerMobile from 'form/components/input/input_datepicker_mobile.jsx';
import InputDecimal from 'form/components/input/input_decimal.jsx';
import InputGridForm from 'grid_form/components/input/input_grid_form';
import InputDocument from 'document/components/input/input_document.jsx';
import InputChart from 'chart/components/input_chart.jsx';
import LabelComponent from 'form/components/label/label_component.jsx';
import LecomLabel from 'form/components/label/label.jsx';
import { forwardPropsToState } from 'utils/react_utils';
import { generateUUID } from 'utils/uuid';
import { getMobileDetect } from 'utils/dom_utils';

import { FormEvents, FormEventHandler } from '../../events/form_event_handler';


// @forwardPropsToState([{prop: 'value'}])
@mixin.decorate(window.CssClassMixin)
export default class InputBase extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		formId: PropTypes.number,
		name: PropTypes.string,
		label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
		value: PropTypes.any,
		component: PropTypes.string,
		formStyle: PropTypes.oneOf(['default', 'filter', 'oneLine']),
		data: PropTypes.object,
		errors: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
		resource: PropTypes.string,
		scope: PropTypes.oneOf(['resource', 'global']),
		maxLength: PropTypes.number,
		renderLabel: PropTypes.bool,
		actions: PropTypes.array,
		helpText: PropTypes.string,
		isLoading: PropTypes.bool,
		gridFormParent: PropTypes.string,
		hidden: PropTypes.bool,
		visible: PropTypes.bool,
		mask: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
	};

	static defaultProps = {
		themeClassKey: 'input',
		value: null,
		component: 'text',
		formStyle: 'default',
		data: {},
		errors: {},
		resource: null,
		scope: 'resource',
		maxLength: null,
		renderLabel: true,
		isLoading: false,
		actions: [],
		gridFormParent: null,
		hidden: false,
		visible: true,
		mask: null,
		onFocus: () => {},
		onBlur: () => {},
		onClick: () => {},
		onChange: () => { return true; }
	};

	componentDidUpdate() {
		if (['masked', 'currency', 'decimal', 'number'].includes(this.getInputComponent()))
			Materialize.updateTextFields();

		if (this.getInputComponent() !== "autocomplete" && this.getInputComponent() !== "checkbox" && this.getInputComponent() !== "radio") {
			const $input = $(ReactDOM.findDOMNode(this.refs.inputComponent));
			$input.off("change").bind("change", this.handleChangeNative.bind(this));
			
			if(this.getInputComponent() !== "number")
				$input.off("blur").bind("blur", this.handleBlurNative.bind(this));			
		}
	}

	componentDidMount() {
		if (this.getInputComponent() !== "autocomplete" && this.getInputComponent() !== "checkbox" && this.getInputComponent() !== "radio") {
			const $input = $(ReactDOM.findDOMNode(this.refs.inputComponent));
			$input.bind("change", this.handleChangeNative.bind(this));

			if(this.getInputComponent() !== "number")
				$input.bind("blur", this.handleBlurNative.bind(this));
		}

		this.focusButtonsActions();
		this.handleTabHelpText();
	}

	handleTabHelpText(){
		let propsHelpText = this.props.helpText;

		if(propsHelpText !== ''){
			let idFieldsHelpText = `#input__${this.props.id} #icon-help-text-modal`;
			$(idFieldsHelpText).attr('tabindex', '0');

			$(idFieldsHelpText).keydown((e) => {
				if(e.keyCode === 13)
					e.currentTarget.click();
			})
		}
	}

	focusFieldsReadOnly(){
		let propsReadOnly = this.props.readOnly;

		if(propsReadOnly === true){
			let idFields = this.props.id;

			$(`#${idFields}`).on('focus', (e) => {
				// $(`#${idFields}`).select();
				e.currentTarget.select();
			})
		}
	}

	focusButtonsActions() {
		$(".material-icons").attr('aria-hidden', true);
		$(".button").attr("role", "button");
		$(".input-datepicker__button").attr("aria-label", Realize.i18n.t('general.description.date'));

		let buttonLookup = $('.button-action-lookup');
		let buttonRefresh = $('.button-action-refresh');
		buttonRefresh.attr("aria-label",Realize.i18n.t('general.description.refresh'));
		buttonLookup.attr("aria-label", Realize.i18n.t('general.description.magnifying_glass'));

		if (this.props.actions.length > 0) {
			let type = this.props.actions[0].searcherType;
			let buttonRadioButton = $('.tab-radio-button');

			buttonLookup.attr('tabindex', '0');
			buttonRefresh.attr('tabindex', '0');
			buttonRadioButton.attr('tabindex', '0');

			if (type === 'refresh') {
				let idRefresh = this.props.actions[0].id

				$(`#${idRefresh}`).keypress((e) => {
					e.which === 13 && e.currentTarget.click();
				})
			}
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		const isTemplateField = this.props.id && this.props.id.search("_templateField") !== -1 ? true : false;
		const isLookupField = this.props.id && this.props.id.search("_lookup-modal") !== -1 ? true : false;

		if (this.props.updateUUID !== nextProps.updateUUID || this.props.readOnly !== nextProps.readOnly || isTemplateField || isLookupField) return true;
		return false;
	}

	handleChangeNative(event) {
		this.publishEvent && this.publishEvent(FormEvents.CHANGE, this.props.value);
	}

	handleBlurNative(event) {
		if(this.publishEvent)
			this.publishEvent(FormEvents.BLUR, this.props.value);
	}

	// New methods

	getRequired() {
		if (this.props.required !== undefined)
			return this.props.required;

		return this.getFieldAPI() ? this.getFieldAPI().required() : false;
	}

	getInputComponentEventListeners() {
		return {
			onFocus: this.handleFocus.bind(this),
			onBlur: this.handleBlur.bind(this),
			onChange: this.handleChange.bind(this),
			onClick: this.handleClick.bind(this)
		};
	}

	maskIsApplicable() {
		const { mask, component } = this.props;
		return mask && ['currency', 'decimal'].includes(component);
	}

	handleFocus(event) {
		this.props.onFocus(event);
	}

	handleBlur(event) {
		this.props.onBlur(event);
	}

	handleChange(event, value) {
		this.props.onChange(event, value);
	}

	handleClick(event) {
		this.props.onClick(event);
	}

	// Overriden methods

	inputClassName() {
		let className = this.className();

		if(!this.props.className) {
			className += ` ${Realize.themes.getCssClass(`input.grid.${this.props.formStyle}`)}`;
		}

		if(this.props.component !== "gridform" && !!this.props.actions && this.props.actions.length > 0) {
			className += ' input-field--with-actions';
		}

		return className;
	}

	getInputComponent() {
		if(this.maskIsApplicable()) return 'masked';

		return this.props.component;
	}

	getInputComponentClass() {
		const component = this.getInputComponent();

		const mapping = {
			text: InputText,
			autocomplete: this.getIsMobile() ? InputSelect : InputSelectSearch, //InputAutocomplete,
			chart: InputChart,
			checkbox: InputCheckbox,
			checkbox_group: InputCheckboxGroup,
			currency: InputCurrency,			
			datefilter: InputDatefilter,
			datepicker: (this.getIsMobile() && getMobileDetect() !== "unknown") ? InputDatepickerMobile : InputDatepicker,
			decimal: InputDecimal,
			document: InputDocument,
			file: InputFile,
			gridform: InputGridForm,
			hidden: InputHidden,
			masked: InputMasked,
			number: InputNumber,
			password: InputPassword,
			radio: InputRadioGroup,
			select: InputSelect,
			switch: InputSwitch,
			textarea: InputTextarea
		};

		return (mapping[component] || window[component] || component);
	}

	labelIsActive(inputValue) {
		const component = this.getInputComponent();
		if (component === 'checkbox')
			return false;

		if (['masked', 'currency', 'decimal', 'radio'].includes(component))
			return true;

		return (inputValue !== null && inputValue !== undefined && String(inputValue).length > 0);
	}

	getInputContainerId() {
		return "input__" + this.props.id;
	}

	getInputComponentName() {
		var inputName = (this.props.name || this.props.id);
		if(this.props.resource !== null && this.props.scope === "resource") {
			inputName = this.props.resource + '[' + inputName + ']';
		}

		return inputName;
	}

	getMaxLength() {
		const acceptComponents = ['text', 'masked', 'decimal', 'number', 'textarea', 'currency'];

		if (!!this.props.maxLength && acceptComponents.includes(this.getInputComponent())) {
			return this.props.maxLength;
		}
	}

	getInputErrors() {
		const { errors, resource, id } = this.props;
		const inputErrorsResource = getObjectKeyPath(resource, errors);
		const inputErrors = getObjectKeyPath(id, inputErrorsResource);

		return inputErrorsResource && inputErrors
			? inputErrors
			: errors[id];
	}

	renderInputIconWarning() {
		if (["NUMBER", "DECIMAL", "CURRENCY"].includes(this.props.type) && this.props.warnings){
			return (
				<div className="tooltipped icon-warning" data-position="top" data-tooltip={this.props.warnings} aria-label={this.props.warnings} tabIndex="0">
					<Icon type="error_outline" aria-hidden={true} />
				</div>
			);
		}

		return null;
	}

	renderInput() {
		if(this.props.type !== 'CHECKBOX'){
			return (
				<div className={this.inputClassName()} id={this.getInputContainerId()}>
					{this.renderLabel()}
					{this.renderComponentInput()}
					{this.renderInputIconWarning()}
					{this.renderActionButtons()}
					{this.renderInputErrors()}
				</div>
			);
		}
		else {
			return (
				<div
					className={this.inputClassName()}
					id={this.getInputContainerId()}
					onBlur={this.handleBlur.bind(this)}
					onFocus={this.handleFocus.bind(this)}
				>
					{this.renderComponentInput()}
					{this.renderLabel()}
					{this.renderActionButtons()}
					{this.renderInputErrors()}
				</div>
			);
		}
	}

	renderLabel() {
		const inputValue = this.getInputComponentValue();
		const isActive = this.labelIsActive(inputValue);

		return ([
			<LecomLabel
				{...this.propsWithoutCSS()}
				id={this.getInputComponentId()}
				active={isActive}
				required={this.getRequired()}
				key={"lecom--label__" + this.getInputComponentId()}
			/>
		]);
	}

	renderInputWithoutLabel() {
		return (
			<div className={this.inputClassName()} id={this.getInputContainerId()}>
				{this.renderComponentInput()}
				{this.renderActionButtons()}
				{this.renderInputErrors()}
			</div>
		);
	}

	renderComponentLabel() {
		return (
			<LabelComponent {...this.props} />
		)
	}

	renderComponentInput() {

		var Component = this.getInputComponentClass(this.getInputComponent());
		var isGrid = (Component === InputGridForm);
		var filterProps = ['type'];

		let actionButtonId;

		if (this.props.actions.length > 0) {
			actionButtonId = this.props.actions[0].id;
		}

		var componentInputProps = Object.assign({}, this.propsWithoutCSS(), {
			originalId: this.props.id,
			originalName: this.props.name,
			id: this.getInputComponentId(),
			name: this.getInputComponentName(),
			errors: isGrid ? this.props.errors : this.getInputErrors(),
			value: this.getInputComponentValue(),
			maxLength: this.getMaxLength(),
			required: this.getRequired(),
			mask: this.props.mask,
			actionButtonId,
			ref: "inputComponent"
		}, this.getInputComponentEventListeners());

		delete componentInputProps.type;
		return <Component {...componentInputProps} />
	}

	renderActionButtons() {
		const { actions } = this.props;
		if(this.props.component === "gridform" || this.isReadOnly()) return <span />;

		return actions
		.filter((actionProps) => !actionProps.hidden)
		.map((actionProps, index) => {
			return (
				<ActionButton
					{...actionProps}
					// cssStyle={this.parseActionButtonCssStyle(index)}
					element="a"
					className={`input-field__action-button button-action-${actionProps.searcherType} action-${actionProps.searcherType}-${this.props.type}`}
					name={null}
					id={actionProps.name}
					disabled={actionProps.disabled || this.props.isLoading}
					key={"input_action__" + this.props.id + index}
				/>
			);
		});
	}

	// Super class methods

	renderAutocompleteInput() {
		return this.renderInputWithoutLabel();
	}

	renderDatefilterInput() {
		return this.renderInputWithoutLabel();
	}

	renderDatepickerInput() {
		return this.renderInputWithoutLabel();
	}

	renderSwitchInput(){
		return this.renderInputWithoutLabel();
	}

	renderFileInput() {
		return this.renderInputWithoutLabel();
	}	

	renderGridformInput() {
		return this.renderInputWithoutLabel();
	}

	renderDocumentInput() {
		return this.renderInputWithoutLabel();
	}

	/*renderChartInput() {
		return this.renderComponentLabel();
	}*/

	renderHiddenInput() {
		return this.renderComponentInput();
	}

	renderTextareaInput() {
		return this.renderInputWithoutLabel();
	}

	renderInputErrors() {
		let typeField = this.props.type;

		if(typeField === 'RADIO'){
			return (<InputError className="error-radiobutton" errors={this.getInputErrors()} />);
		}
		else if(typeField === 'CHECKBOX'){
			return (<InputError className="error-checkbox" errors={this.getInputErrors()} />);
		} else {
			return (<InputError errors={this.getInputErrors()} />);
		}
	}

	getInputComponentId() {
		var inputId = this.props.id;
		if(this.props.resource !== null && this.props.scope === "resource") {
			inputId = this.props.resource + '_' + inputId;
		}

		return inputId;
	};

	getInputComponentValue() {
		const { value, data, id, component } = this.props;

		return !!value || value === '' || typeof value === "number"
			? value
			: getObjectKeyPath(id, data || {});
	};

	getFieldAPI() {
		if (this.props.formId) {
			const formAPI = FormAPI.form(this.props.formId);
			return (this.props.gridFormParent)
				? formAPI.fields(this.props.gridFormParent).fields(this.props.id)
				: formAPI.fields(this.props.id);
		}
		return null;
	}

	getIsMobile() {
		const processAPI = ProcessAPI.currentProcess();
		const isMobile = processAPI.isMobile();
		return isMobile;
	}

	setTabIndexListErrors(){
		setTimeout(() => {
			const listErrors = document.querySelectorAll('.form__input-error');
			Array.prototype.forEach.call(listErrors, (elem)=>{
				if(elem.innerHTML.trim() !== ""){
					elem.setAttribute('tabindex', 0);
				}
			})
		}, 100);
	}

	render() {
		this.setTabIndexListErrors();

		const renderFunction = `render${S(this.getInputComponent()).capitalize().s}Input`;
		let renderLabel = this.props.renderLabel;

		if (this.getIsMobile() && this.props.component === 'select')
		renderLabel = false;

		if(this.props.hidden)
		return <span/>;

		if(typeof this[renderFunction] == "function") {
			return this[renderFunction]();
		} else if(!renderLabel) {
			return this.renderInputWithoutLabel();
		} else if (this.props.component === "label"){
			return this.renderComponentLabel();
		}

		return this.renderInput();
	}

	getValue() {
		const inputComponentRef = this.refs.inputComponent;
		if(inputComponentRef && typeof inputComponentRef.getValue === "function") {
			return inputComponentRef.getValue();
		} else {
			return this.getInputComponentValue();
		}
	};

	serialize() {
		const inputComponentRef = this.refs.inputComponent;
		if(inputComponentRef && typeof inputComponentRef.serialize === "function") {
		  return inputComponentRef.serialize();
		}

		return { [this.getName()]: this.getValue() };
	}

	isReadOnly() {
		return this.props.readOnly;
	}

	getName() {
		return this.getInputComponentName();
	}
}
